import type { User } from '@/@types/user'
import { css } from '@emotion/react'
import { Link } from '@tanstack/react-router'
import type { HTMLAttributes } from 'react'

export interface ScreenNameProps extends HTMLAttributes<HTMLDivElement> {
	data: User
	readonly?: boolean
}

export default function ScreenName({ data, readonly = false, ...props }: ScreenNameProps) {
	const { username, screenName, trailingIcons } = data

	return (
		<div
			{...props}
			css={css`
				display: inline-flex;
				gap: 0.1em;
				align-items: center;
			`}
		>
			<Link
				onClick={(e) => {
					e.stopPropagation()
				}}
				to="/u/$username"
				params={{
					username,
				}}
				disabled={readonly}
				aria-readonly={readonly}
				className="jk-link-text"
				css={css`
					color: var(--tint-primary);
				`}
			>
				<span
					css={css`
						position: relative;
					`}
				>
					{screenName}
				</span>
			</Link>

			{trailingIcons && (
				<div
					css={css`
						display: inline-flex;
						gap: 2px;
					`}
				>
					{trailingIcons.map((icon, i) => (
						<img
							width={16}
							height={16}
							src={icon.picUrl}
							key={icon.picUrl}
							css={css`
								aspect-ratio: 1;
								height: 1em;
							`}
						/>
					))}
				</div>
			)}
		</div>
	)
}
